ko.bindingHandlers.fadeSlideTemplate = {
  init: function(element, valueAccessor, allBindings) {
    return ko.bindingHandlers['template']['init'](element, valueAccessor, allBindings);
  },
  update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
    var $element, fromHeight, newValueAccessor, toHeight, value;
    value = ko.unwrap(valueAccessor());
    if (typeof value === 'object') {
      value.name = ko.unwrap(value.name);
      if (!value.name) {
        throw 'When using the fadeSlideTemaple binding and passing an object there must be a property "name" that defines the template to use.';
      }
    }
    $element = $(element);
    fromHeight = $element.height();
    newValueAccessor = function() {
      return value;
    };
    if (fromHeight === 0) {
      ko.bindingHandlers['template']['update'](element, newValueAccessor, allBindings, viewModel, bindingContext);
    } else {
      $element.css({
        'overflow': 'hidden',
        'opacity': 0
      });
      ko.bindingHandlers['template']['update'](element, newValueAccessor, allBindings, viewModel, bindingContext);
      toHeight = $element.height();
      $element.height(fromHeight);
      $element.animate({
        opacity: 1,
        height: toHeight
      }, {
        duration: 300,
        complete: function() {
          return $element.css({
            height: 'auto',
            overflow: 'auto'
          });
        }
      });
    }
  }
};
